export default __webpack_public_path__ + "static/pete-making-it-rain-bg-37cc9540f1584e452722cbce45744989.png";